module.exports = __webpack_public_path__ + "assets/img/img326.5083a5d6.png";